import { Routes } from '@angular/router';
import { CustomerGuard } from '@next/core-lib/relationships';

import { VirusDashboardComponent } from './virus-dashboard.component';

export const virusDashboardRoutes: Routes = [
  {
    path: 'virus-dashboard',
    component: VirusDashboardComponent,
    canActivate: [CustomerGuard],
  },
];
